import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import RefineAuthorizationListResponsiveTableRow from './RefineAuthorizationListResponsiveTableRow';

const RefineAuthorizationListResponsiveTableBody = ({ userGroups, authorization, allowedStates, dispatch, changedRefinePermissions }) => {
  return (
    <TableBody>
      {allowedStates?.map(documentState => {
        return (
          <RefineAuthorizationListResponsiveTableRow
            key={documentState.documentTypeId + '_' + documentState.documentStateId}
            authorization={authorization}
            userGroups={userGroups}
            documentState={documentState}
            dispatch={dispatch}
            authorizationRefineChangedPermissions={changedRefinePermissions || {}}
          />
        );
      })}
    </TableBody>
  );
};

RefineAuthorizationListResponsiveTableBody.propTypes = {
  changedRefinePermissions: PropTypes.object.isRequired,
  authorization: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  allowedStates: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default RefineAuthorizationListResponsiveTableBody;
